import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'
import { baseAttr } from '@/store/exam-question/qb-question'

export default {
  // eslint-disable-next-line consistent-return
  async getDataSourcesTrash(params) {
    try {
      const response = await axios.get('uni/qbQuestions/getQbQuestionTrash', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async deleteDataSource(id) {
    try {
      const response = await axios.delete(`uni/qbQuestions/${id}`)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async deleteMultiple(params) {
    try {
      const response = await axios.put('uni/qbQuestions', params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async revert(id) {
    try {
      const response = await axios.put(`uni/qbQuestions/revert/${id}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async revertMultiple(params) {
    try {
      const response = await axios.put('uni/qbQuestions/revertMultiple', params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
